import styled from "styled-components";

const Text = styled.span`
  display:inline-block;
  margin: 10px 0;
  padding: 5px 0;
  color: ${props => props.theme.textcolor};
  font-family: Nunito;
`;

const Link = styled.a`
  color:${props => props.theme.textcolor};
  text-decoration: none;
  &:link, &:visited {
    color:${props => props.theme.textcolor};
  }
`;

const Footer = () => {
  return (
    <Text>by <Link href="https://github.com/sxnaprkhr" target="_blank" rel="noreferrer noopener">sxnaprkhr</Link></Text>
  );
};

export default Footer;